import { supabase } from './supabase';
import { API_BASE_URL } from './apiConfig';

/**
 * Drop-in replacement for fetch() that:
 * - Automatically prepends API_BASE_URL when given a relative path
 * - Signs the user out and reloads to /login on any 401 response
 */
export async function apiFetch(
  input: string,
  init?: RequestInit
): Promise<Response> {
  const url = input.startsWith('http') ? input : `${API_BASE_URL}${input}`;
  const response = await fetch(url, init);

  if (response.status === 401) {
    // Sign out silently — onAuthStateChange(SIGNED_OUT) will fire and
    // ProtectedRoute will redirect to /login via React Router.
    // Do NOT use window.location.href here: that causes a full page
    // reload, which re-runs getSession() before signOut clears
    // localStorage, creating an infinite /me → 401 → reload loop.
    supabase.auth.signOut();
    return response;
  }

  return response;
}
